import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styles from './App.module.css';

// Import AppRoutes component from routes.js
import AppRoutes from '../routes';

function App() {
  return (
    <div className={styles.app}>
      <Router>
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App; 